import { Cookies } from 'react-cookie';

import { CreatePeriodReportFormValues } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface CreatePeriodReportInterface {
  createPeriodReportData: CreatePeriodReportFormValues;
  slug: string;
}

export const createPeriodReport = async ({ createPeriodReportData, slug }: CreatePeriodReportInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    `/period_report/${slug}/`,
    {
      ...createPeriodReportData,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
